<!--
	Alert Mixins
	As used on the logged in home page, and in the top of the job search page.
-->
<script>
	export default {
		computed: {
			savedAlerts() {
				return (!this.me) ? [] : this.me['saved-alerts'];
			},
			filteredAlerts() {
				return this.savedAlerts.filter(
					(alert) =>
						alert.active == true &&
						alert.id !== "" &&
						alert.query !== "" &&
						alert.type !== "personalised"
				);
			},
		}
	}
</script>
